class RecapUtility

  @validPhotos: (recap) ->
    recap.photos.filter((photo) => photo not in recap.photos_invalid)

  @labelForAnswer: (answer, question) ->
    switch question.component
      when 'radio-button'
        question.input_props?.options?.find((item) => item.value is answer)?.label
      when 'checkbox-button'
        question.input_props?.options?.find((item) => item.value is value)?.label for value in answer
      else
        answer

  @isAnswered: (answer = '') ->
    return false if answer is ''
    return false if Array.isArray(answer) and answer.length is 0
    true

  @answers: (recap) ->
    questions = @visibleQuestions recap
    answers = Object.entries recap.answers
    answers = answers.filter(([key, answer]) => questions[key] and @isAnswered(answer))
    Object.fromEntries answers

  @requiredAnswers: (recap) ->
    questions = @requiredQuestions recap
    answers = Object.entries recap.answers
    answers = answers.filter(([key, answer]) => questions[key] and @isAnswered(answer))
    Object.fromEntries answers

  @visibleQuestions: (recap) ->
    questions = Object.entries recap.question_template
    questions = questions.filter(([key, question]) => @displayQuestion(question, recap.answers))
    Object.fromEntries questions

  @requiredQuestions: (recap) ->
    questions = Object.entries(@visibleQuestions(recap))
    questions = questions.filter(([key, question]) => question.options?.required)
    Object.fromEntries questions

  @displayQuestion: (question, answers) ->
    return true unless question.depends_on?.length
    return true for dependency in question.depends_on when @matchesDependency dependency, answers
    false

  @matchesDependency: (dependency, answers) ->
    { key, method, value } = dependency
    @[method](answers[key], value)

  @if_equal: (answer, value) ->
    answer is value

  @if_contains: (answer, value) ->
    return false unless value?
    answers = if Array.isArray(answer) then answer else [answer]
    answers.some((v) => String(v).includes String(value))

export default RecapUtility
